import {useNavigate, useParams} from "react-router-dom";
import {useIntl} from "react-intl";
import {Card, CategoryTitle, EmblaCarousel, GameAccordion, GameBanner, Page, PageNavigationBar} from "@housebets/housebets-x-package";
import {EMBLA_OPTIONS} from "../../components/constants/embla";
import {Providers} from "../../components/features/lists/Providers";
import {LiveBets} from "../../components/features/tables/LiveBets";
import {getMappedCard} from "../../utils/help";
import {useGameData} from "./hooks/useGameData";
import {useEffect, useRef, useState} from "react";
import {disableUserPlayRealGame, enableUserPlayRealGame} from "../../store/slices/game";
import {useDispatch} from "react-redux";
import {MainLoader} from "app/components";
import {seoDefaultData} from "app/components/constants/seo";
import {useLangNavigate} from "app/hooks/useLangNavigate";

import {loadLocaleData, extractLocaleFromUrl} from "app/utils/locales";

export function meta({data}) {
    return [
        {title: data.messages["seo.title"]},
        {
            name: "description",
            content: data.messages["seo.description"],
        },
        {
            name: "keywords",
            content: data.messages["seo.keywords"],
        },
        { property: "og:title", content: data.messages["seo.title"] },
        { property: "og:description", content: data.messages["seo.description"] },
        { property: "og:image:alt", content: data.messages["seo.og.image"] },
    ];
}

export async function loader({request, params}) {
    const locale = extractLocaleFromUrl(request);
    let messages;

    await loadLocaleData(locale).then((d: {default: Record<string, string> | Record<string, MessageFormatElement[]> | undefined}) => {
        messages = d.default;
    });

    return {messages};
}

const GamePage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {$t} = useIntl();
    const {
        isMobile,
        isTablet,
        gameData,
        isDemoMode,
        isCollect,
        setIsDemoMode,
        onMaxClick,
        onCollectClick,
        currencyOpt,
        selectedId,
        onSelectChange,
        playHandler,
        showGameBanner,
        gameUrl,
        iframeRef,
        setIsLoadingGame,
        isLoadingGame,
        relatedGames,
        gameIframeRef,
        sendAuthTokenToIframe,
        isWidgetGame,
    } = useGameData();

    console.log("relatedGames", relatedGames);

    const [isReady, setIsReady] = useState(false);

    const param = useParams();
    const langNavigate = useLangNavigate();

    useEffect(() => {
        import("housebets-game-game/dist/dice-game.js").then(() => {
            setIsReady(true);
        });
        return () => {
            dispatch(disableUserPlayRealGame());
        };
    }, []);

    return (
        <>
            <Page.Wrapper>
                {!isMobile && !isTablet && (
                    <Page.Row padding>
                        <PageNavigationBar
                            prevButtonHref=""
                            fairText={$t({id: "ProvablyFair"})}
                            showLogo={false}
                            title={gameData.gameName}
                            subtitle={gameData.providerName}
                            prevButtonClick={() => {
                                navigate(-1);
                            }}
                            switchButton={
                                gameData.hasDemo
                                    ? {
                                          checked: isDemoMode,
                                          onChange: (check) => {
                                              setIsDemoMode(check);
                                          },
                                      }
                                    : undefined
                            }
                            maxButton={{
                                onClick: onMaxClick,
                            }}
                            collectButton={{
                                onClick: onCollectClick,
                                active: isCollect,
                            }}
                        />
                    </Page.Row>
                )}

                {/* TODO: need to finish migrate to packages */}
                <Page.Row padding topPaddingOff={!isMobile}>
                    <GameBanner
                        id="game-container"
                        playModalProps={
                            showGameBanner
                                ? {
                                      isOpen: showGameBanner,
                                      selectedID: [selectedId],
                                      onClose: () => {},
                                      onRealPlayClick: () => {
                                          dispatch(enableUserPlayRealGame());
                                          playHandler(false);
                                      },
                                      onSelect: onSelectChange,
                                      options: currencyOpt,
                                      demoPlay: isDemoMode,
                                      onDemoPlayClick: () => {
                                          playHandler(true);
                                      },
                                  }
                                : null
                        }
                        showPreview={false}
                        mainBackgroundColor="#000000"
                        preview={{
                            alt: "",
                            url: "/img/game-iframe/1.png",
                        }}
                        onBannerClick={() => {}}>
                        {!isWidgetGame && gameUrl && (
                            <div style={{position: "absolute", left: 0, top: 0, width: "100%", height: "100%", zIndex: 11119}} ref={iframeRef}>
                                <iframe
                                    id="gameContainer"
                                    scrolling="no"
                                    allow="autoplay; clipboard-write; fullscreen"
                                    src={gameUrl}
                                    style={{width: "100%", height: "100%", border: "none", backgroundColor: "#000000"}}
                                    onLoad={() => {
                                        setIsLoadingGame(false);
                                    }}></iframe>
                            </div>
                        )}

                        {isWidgetGame && isReady && (
                            <dice-game
                                className="f-hull"
                                // gameserver={"https://test-housegames-backend-486795145799.asia-southeast1.run.app"}
                                // walletserver={"https://test-housegames-backend-486795145799.asia-southeast1.run.app"}
                                theme={"dark"}
                            />
                        )}

                        {isLoadingGame ? (
                            <div
                                style={{
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    width: "100%",
                                    height: "100%",
                                    padding: "20px 8px",
                                    paddingLeft: "16px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    zIndex: 122220,
                                    backgroundColor: "#000000",
                                }}>
                                {/* <MainLoader /> */}
                            </div>
                        ) : null}
                    </GameBanner>
                </Page.Row>

                {/* TODO: to delete after migrated to packages */}
                {/* <Page.Row
                    style={{
                        position: 'relative'
                    }}
                    padding
                    topPaddingOff={!isMobile}
                >
                    <GameBanner
                        currencyList={currencyOpt}
                        selectedId={selectedId}
                        onSelectChange={onSelectChange}
                        playHandler={playHandler}
                        showGameBanner={showGameBanner}
                        demoPlay={isDemoMode}
                        style={{
                            // border: "1px solid #08333c",
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#000000",
                        }}
                    />

                    {gameUrl && (
                        <div
                            style={{ position: "absolute", left: 0, top: 0, width: "100%", height: "calc(100% - 20px)", zIndex: 9, }}
                            ref={iframeRef}
                        >
                            <iframe
                                id="gameContainer"
                                scrolling="no"
                                allow="autoplay; clipboard-write; fullscreen"
                                src={gameUrl}
                                style={{ width: "100%", height: "100%", border: "none", backgroundColor: "#000000" }}
                                ref={gameIframeRef}
                                onLoad={() => {
                                    setIsLoadingGame(false);
                                    // Send authentication token to the iframe after it loads
                                    sendAuthTokenToIframe();
                                }}
                            >
                            </iframe>
                        </div>
                    )}

                    {isLoadingGame && (
                        <div
                            style={{
                                position: "absolute",
                                left: 0,
                                top: 0,
                                width: "100%",
                                height: "100%",
                                padding: "20px 8px",
                                paddingLeft: "16px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 10,
                                backgroundColor: "#000000",
                            }}>
                            <MainLoader />
                        </div>
                    )}
                </Page.Row> */}
                {/* TODO: to delete after migrated to packages */}

                {(isMobile || isTablet) && (
                    <Page.Row padding>
                        <PageNavigationBar
                            title={gameData.gameName}
                            subtitle={gameData.providerName}
                            prevButtonHref={langNavigate("/")}
                            showLogo={false}
                            fairText={$t({id: "ProvablyFair"})}
                            size="sm"
                            switchButton={
                                gameData.hasDemo
                                    ? {
                                          checked: isDemoMode,
                                          onChange: (check) => {
                                              setIsDemoMode(check);
                                          },
                                      }
                                    : undefined
                            }
                            maxButton={{
                                onClick: onMaxClick,
                            }}
                            collectButton={{
                                onClick: onCollectClick,
                                active: isCollect,
                            }}
                        />
                    </Page.Row>
                )}

                {!!gameData.gameId && (
                    <Page.Row
                        padding
                        // fix animation trigger after accordion collapsed
                        animated
                        position={3}>
                        <GameAccordion
                            edge={+(100 - parseFloat(gameData.rtp + "")).toFixed(2)}
                            tags={[]}
                            title={gameData.gameName}
                            gameData={getMappedCard(gameData, langNavigate)}
                            description={gameData.gameDesc || gameData.providerName}
                            // fix animation trigger after accordion collapsed
                            animation={null}
                        />
                    </Page.Row>
                )}
                {relatedGames?.length ? (
                    <Page.Row>
                        <EmblaCarousel
                            title={<CategoryTitle icon="Flash" title={$t({id: "MoreFrom"}) + relatedGames[0]?.brandVo?.brandName} />}
                            options={EMBLA_OPTIONS}
                            partialSlides
                            viewAll={langNavigate("/?type=Lobby")}
                            shadow
                            text={{
                                viewAll: $t({id: "ViewAll"}),
                            }}
                            navigation
                            slides={relatedGames.map((item) => {
                                const mapped = getMappedCard(item, langNavigate);
                                return <Card {...mapped} key={mapped.id} />;
                            })}
                        />
                    </Page.Row>
                ) : null}

                <Page.Row>
                    <Providers />
                </Page.Row>

                <Page.Row padding>
                    <LiveBets />
                </Page.Row>
            </Page.Wrapper>
        </>
    );
};

export default GamePage;
